import i18n from 'i18next';
import { registerValidator } from 'core/forms';

const isNotEmptyHTML = ({ fieldValue, condition }) => {
  const isRequired = !condition?.shouldHideField;

  return {
    error: i18n.t('error-required-field-error'),
    hasError:
      isRequired &&
      (!fieldValue ||
        !new DOMParser().parseFromString(fieldValue, 'text/html').body.textContent.trim().length),
    isRequired,
  };
};

registerValidator('isNotEmptyHTML', isNotEmptyHTML);

export default isNotEmptyHTML;
